<template>
    <div class="mw-fast-news bgWhite p15">
        <h3><img src="../assets/images/kxunxinxi.png" alt="" srcset=""></h3>
        <div class="content">
            <div class="fast-news-list" v-for="(item, index) in newflash_list" :key="index" :title="item.newsTxt">
                <span class="fontWhite">{{ item.newsDate.substr(11, 5) }}</span><br>
                <div class="fontLight">{{ item.newsTxt }}</div>
            </div>
        </div>

        <!-- <div class="fast-news-ad">
            <a :href="link ? link : ''" target="_blank" rel="">
                <img :src="ad ? ad : defaultAd" alt="" style="height: 80px;" class="w100">
            </a>
        </div> -->
    </div>
</template>

<script>
import { baseUrl } from '../assets/js/common'
export default {
    name: 'FastNewsControl',
    components: { },
    props: {
        ad: String,
        link: String
    },
    data () {
        return {
            defaultAd: require('../assets/images/ad_1.png'),
            newflash_list: []
        }
    },
    mounted () {
        // 初始化内容
        this.newflashFindList();
    },
    methods: {
        // 获取快讯排行
        newflashFindList () {
            const self = this;
            self.$post(`${baseUrl.cyw}/newflash/findList/0/5`, {}).then(res => {
                if (res.code == 0) {
                    self.newflash_list = res.data;
                }else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('未获取到快讯信息');
            })
        },
    },
}
</script>

<style scoped>
    .mw-fast-news { height: 400px; }
    .mw-fast-news h3 { padding-bottom: 10px; }
    .mw-fast-news .ad { height: 90px; margin: 15px 0; }
    .mw-fast-news .fast-news-list { padding: 10px 0; border-bottom: 1px solid #ececec; }
    .mw-fast-news .fast-news-list:last-child { border: 0; }
    .mw-fast-news .fast-news-list span { padding: 1px 10px; background: #a30000; border-radius: 3px; }
    .mw-fast-news .fast-news-list div { 
        line-height: 22px; 
        margin-top: 10px;
    }
    .content { height: 370px; overflow: auto; }
    .content::-webkit-scrollbar {display:none}
</style>